import React from 'react';
import { FormControlLabel } from '@material-ui/core';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import { StyledCheckbox } from './FsCheckboxWithLabel.style-elements';

interface FsCheckboxWithLabelProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  label: string;
}

const FsCheckboxWithLabel: React.FC<FsCheckboxWithLabelProps> = ({
  checked,
  onChange,
  name,
  label,
}) => {
  return (
    <FormControlLabel
      control={
        <StyledCheckbox checked={checked} onChange={onChange} name={name} />
      }
      label={
        <FsBodySmall style={{ whiteSpace: 'nowrap' }}>{label}</FsBodySmall>
      }
    />
  );
};

export default FsCheckboxWithLabel;
